import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import routes from './routes'

import paymentNoticeRoutes from '../modules/payment-notices/router'
import officailReceiptRoutes from '../modules/official-receipts/router'
import receiptRoutes from '../modules/receipts/router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes: [...routes, ...paymentNoticeRoutes, ...officailReceiptRoutes, ...receiptRoutes]
})

router.beforeEach((to, from, next) => {
  if (to.name == 'scan') {
    next()
  }
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (store.getters.authenticated) {
      next()
    } else {
      next({ name: 'login', query: { redirectTo: to.fullPath } })
    }
  } else if (to.matched.some(route => route.meta.requiresGuest)) {
    if (!store.getters.authenticated) {
      next()
    } else if (store.getters.authenticated && to.name != 'scan') {
      next({ name: 'home' })
    }
  } else {
    next()
  }
})

export default router
